enum EntityContext {
  ACCOUNT = 'ACCOUNT',
  ORGANIZATION = 'ORGANIZATION',
  CUSTOMER = 'CUSTOMER',
}

export default EntityContext;
